import { GreenBold } from 'components/Tables/ActivityTableV2/CellEvent/CellEventFormatter'
import { CellEventFormatterProps } from '../../utils'

/**
 * Custom handler for contact UPDATE events.
 * Shows the contact name from field_history_objects for events like starring a contact.
 */
export const ContactUpdateEvent = ({ event }: CellEventFormatterProps) => {
  // Get contact name from field_history_objects (stored in contact_company_name field)
  const contactName =
    event.field_history_objects?.[0]?.contact_company_name || 'a contact'

  // Handle starred field specifically
  if (event.field_name === 'starred') {
    const isStarred = event.value?.[0] === 'true' || event.value?.[0] === true
    return (
      <>
        {isStarred ? 'starred' : 'unstarred'}{' '}
        <GreenBold>{contactName}</GreenBold>
      </>
    )
  }

  // Default handling for other contact update fields
  return (
    <>
      updated <GreenBold>{contactName}</GreenBold>
    </>
  )
}
